import {heartFilledSvg as Icon__small__heartFilledSvg} from '../Icon__small/Icon__small--heartFilled.js';

export var heartFilled = {
  name: 'heartFilled',
  category: 'icon',
  colorable: true,
  svg: Icon__small__heartFilledSvg,
};
